import { render, staticRenderFns } from "./AddNews.vue?vue&type=template&id=2c7e36b6&scoped=true&"
import script from "./AddNews.vue?vue&type=script&lang=js&"
export * from "./AddNews.vue?vue&type=script&lang=js&"
import style0 from "./AddNews.vue?vue&type=style&index=0&id=2c7e36b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e36b6",
  null
  
)

export default component.exports